import P from '../pages';
import FormHeader from './FormHeader';
import Alert from './Alert';
import { defaultMessages } from '../../../libs/i18n/default';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import FormControl from 'react-bootstrap/lib/FormControl';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import { CustomFormGroup, Form } from '../../../shared/components';
import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { pageValid, fieldsToValidate } from '../../../shared/validator';
import { guestProfileSubmit } from '../actions';
import withDefaults from './withDefaults'
import CheckboxOrRadioGroup from './CheckboxOrRadioGroup';
import { changeState } from '../../../shared/utilities';
import { generateProfileElementObject } from '../../../shared/profileElementHelpers';

const LanguageNationality = ({ content, dispatch, page, environment, intl: { formatMessage } }) => {
  const thisPage = P.LANGUAGE_NATIONALITY_PAGE;
  const [submitted, setSubmitted] = useState(false)
  const languageOptions = useSelector(state => state.languageOptions)
  const ethnicityOptions = useSelector(state => state.ethnicityOptions)
  const [fields, setFields] = useState({
    passportNo: generateProfileElementObject('', 'personal', 'passport_no'),
    passportCountry: generateProfileElementObject('', 'personal', 'passport_country'),
    homeLanguage: generateProfileElementObject('', 'personal', 'home_language'),
    englishLevel: generateProfileElementObject('', 'personal', 'english_level'),
    hobbiesInterests: generateProfileElementObject('', 'personal', 'hobbies_interests'),
    reasonForHomestay: generateProfileElementObject('', 'personal', 'reason_for_homestay'),
    visaApproved: generateProfileElementObject('', 'personal', 'visa_approved'),
    visaApplyDate: generateProfileElementObject('', 'personal', 'visa_apply_date'),
  })
  const [showVisaApplyDate, setShowVisaApplyDate] = useState(false)
  const [notApplicable, setNotApplicable] = useState(false);
  const fieldsRef = useRef(fields)
  fieldsRef.current = fields

  useEffect(() => {
    fieldsToValidate(fields).forEach(f => {
      handleChange(f, fields[f].val, false)
    })

    setShowVisaApplyDate(fields.visaApproved.val == 'No')
    setNotApplicable(fields.visaApplyDate.val == 'Not Applicable')
  }, [])

  const handleChange = (key, val, resetDependentObject = true) => {
    changeState(
      fieldsRef.current,
      key,
      val,
      (newObj) => {
        setFields({...fieldsRef.current, ...newObj})
      },
      resetDependentObject
    )
  }

  const handleVisaApproved = (e) => {
    e.preventDefault()

    if (e.target.value == 'No') {
      handleChange('visaApproved', e.target.value)
      setShowVisaApplyDate(true)
    } else {
      handleChange('visaApproved', e.target.value)
      handleChange('visaApplyDate', '')
      setShowVisaApplyDate(false)
    }
  }

  const handleNotApplicable = () => {
    setNotApplicable(!notApplicable)
    handleChange('visaApplyDate', '')
  }

  const submit = (e) => {
    e.preventDefault()
    const applyDate = notApplicable ? 'Not Applicable' : fields.visaApplyDate.val
    setSubmitted(true)
    dispatch(guestProfileSubmit({
      personal: {
        passport_no: fields.passportNo.val,
        passport_country: fields.passportCountry.val,
        home_language: fields.homeLanguage.val,
        english_level: fields.englishLevel.val,
        hobbies_interests: fields.hobbiesInterests.val,
        reason_for_homestay: fields.reasonForHomestay.val,
        visa_approved: fields.visaApproved.val,
        visa_apply_date: applyDate,
      }
    }, thisPage))
  }

  return (
    <Form page={page} thisPage={thisPage} back={true} skip={environment != 'production'} submitFunc={submit} disableSubmit={!pageValid(fields) || submitted} >
      <FormHeader title={content.pages.language_nationality.title} />
      <div className='two-columns'>
        <div style={{flex: '50%'}}>
          <CustomFormGroup field={fields.passportNo}>
            <ControlLabel>{formatMessage(defaultMessages.clientGuestPagesLanguageNationalityLabelsPassport)}</ControlLabel>
            <FormControl id="passportNo"
              type="text"
              componentClass="input"
              defaultValue={fields.passportNo.val}
              onChange={(e) => handleChange(e.target.id, e.target.value)} />
          </CustomFormGroup>
        </div>

        <div style={{flex: '50%'}}>
          <CustomFormGroup field={fields.passportCountry}>
            <ControlLabel>{formatMessage(defaultMessages.clientGuestPagesLanguageNationalityLabelsPassportCountry)}</ControlLabel>
            <FormControl id="passportCountry"
              type="select"
              componentClass="select"
              defaultValue={fields.passportCountry.val}
              onChange={(e) => handleChange(e.target.id, e.target.value)}>
              <option value="" key="select">{formatMessage(defaultMessages.clientCommonSelectsSelect)}</option>
              {ethnicityOptions.map((opt, index) => {
                 return (
                  <option
                    key={`${opt[1]}_${index}`}
                    value={opt[1]}>{opt[0]}</option>
                  );
               })}
            </FormControl>
          </CustomFormGroup>
        </div>
      </div>

      <div className='two-columns'>
        <div style={{flex: '50%'}}>
          <CustomFormGroup field={fields.homeLanguage}>
            <ControlLabel>{formatMessage(defaultMessages.clientGuestPagesLanguageNationalityLabelsLanguage)}</ControlLabel>
            <FormControl id="homeLanguage"
              type="select"
              componentClass="select"
              defaultValue={fields.homeLanguage.val}
              onChange={(e) => handleChange(e.target.id, e.target.value)} >
              <option value="" key="select">{formatMessage(defaultMessages.clientCommonSelectsSelect)}</option>
              {languageOptions.map((opt, index) => {
                 return (
                  <option
                    key={`${opt[1]}_${index}`}
                    value={opt[1]}>{opt[0]}</option>
                  );
               })}
            </FormControl>
          </CustomFormGroup>
        </div>

        <div style={{flex: '50%'}}>
          <CustomFormGroup field={fields.englishLevel}>
            <ControlLabel>{formatMessage(defaultMessages.clientGuestPagesLanguageNationalityLabelsEnglishLevel)}</ControlLabel>
            <FormControl id="englishLevel"
              type="select"
              componentClass="select"
              defaultValue={fields.englishLevel.val}
              onChange={(e) => handleChange(e.target.id, e.target.value)} >
              <option value="" key="select">{formatMessage(defaultMessages.clientCommonSelectsSelect)}</option>
              <option value="Beginner" key="Beginner">{formatMessage(defaultMessages.clientGuestPagesLanguageNationalitySelectOptionsBeginner)}</option>
              <option value="Intermediate" key="Intermediate">{formatMessage(defaultMessages.clientGuestPagesLanguageNationalitySelectOptionsIntermediate)}</option>
              <option value="Advanced" key="Advanced">{formatMessage(defaultMessages.clientGuestPagesLanguageNationalitySelectOptionsAdvanced)}</option>
            </FormControl>
          </CustomFormGroup>
        </div>
      </div>

      <CustomFormGroup field={fields.hobbiesInterests}>
        <ControlLabel>{formatMessage(defaultMessages.clientGuestPagesLanguageNationalityLabelsHobbies)}</ControlLabel>
        <FormControl id="hobbiesInterests"
          type="text"
          componentClass="textarea"
          defaultValue={fields.hobbiesInterests.val}
          onChange={(e) => handleChange(e.target.id, e.target.value)} />
      </CustomFormGroup>

      <CustomFormGroup field={fields.visaApproved}>
        <ControlLabel>{formatMessage(defaultMessages.clientGuestPagesLanguageNationalityLabelsVisaApproved)}</ControlLabel>
        <FormControl id="visaApproved"
          type="select"
          componentClass="select"
          defaultValue={fields.visaApproved.val}
          onChange={handleVisaApproved}>
          <option value="select" key="select">{formatMessage(defaultMessages.clientCommonYesNo)}</option>
          <option value="Yes" key="Yes">{formatMessage(defaultMessages.clientCommonAffirmative)}</option>
          <option value="No" key="No">{formatMessage(defaultMessages.clientCommonNegative)}</option>
        </FormControl>
      </CustomFormGroup>

      {showVisaApplyDate && (
        <>
          <CustomFormGroup field={fields.visaApplyDate}>
            <ControlLabel>{formatMessage(defaultMessages.clientGuestPagesLanguageNationalityLabelsVisaApplyDate)}</ControlLabel>
            <div>
              <input
                id="visaApplyDate"
                type="date"
                value={fields.visaApplyDate.val}
                onChange={(e) => handleChange(e.target.id, e.target.value)}
                disabled={notApplicable}
              />
              <label style={{ marginLeft: '10px' }}>
                <input
                  id="notApplicable"
                  type="checkbox"
                  checked={notApplicable}
                  onChange={handleNotApplicable}
                /> Not applicable
              </label>
            </div>
          </CustomFormGroup>
        </>
      )}

      <CustomFormGroup field={fields.reasonForHomestay}>
        <ControlLabel>{formatMessage(defaultMessages.clientGuestPagesPersonalityProfileLabelsReasonForHomestay)}</ControlLabel>
        <FormControl id="reasonForHomestay"
          type="text"
          componentClass="textarea"
          defaultValue={fields.reasonForHomestay.val}
          onChange={e => handleChange(e.target.id, e.target.value)} />
      </CustomFormGroup>

      <Alert alert={content.pages.language_nationality.info} />
    </Form>
  )
}

export default withDefaults(LanguageNationality)
